import PropTypes from 'prop-types';

const MoonIcon = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="1 1 14 14" // ⬅️ restringi il box visivo
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
  >
    <path
      d="M8 1.328C6.79314 1.32822 5.60897 1.65605 4.57382 2.27651C3.53866 2.89697 2.69135 3.78679 2.12227 4.85106C1.55318 5.91532 1.28367 7.1141 1.34248 8.31953C1.40129 9.52496 1.78621 10.6918 2.4562 11.6956C3.12618 12.6994 4.05608 13.5026 5.14672 14.0193C6.23736 14.5361 7.44781 14.7471 8.64896 14.6298C9.85011 14.5125 10.9969 14.0714 11.967 13.3535C12.9371 12.6356 13.6941 11.6678 14.1573 10.5533C14.3847 10.0067 13.84 9.45733 13.292 9.68C12.3528 10.0604 11.3099 10.0997 10.3448 9.79095C9.37961 9.4822 8.55318 8.84495 8.00916 7.99001C7.46515 7.13508 7.23796 6.11652 7.3671 5.11144C7.49623 4.10635 7.97353 3.17831 8.716 2.48867L8.76733 2.43533C9.13467 2.01533 8.84267 1.33333 8.262 1.33333H8.08467L8.03933 1.32933L7.99933 1.328H8Z"
      fill={color}
    />
  </svg>
);

MoonIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MoonIcon.defaultProps = {
  color: '#C8CBD0',
  size: 16,
};

export default MoonIcon;
